<template>
<div ref="meterMap"></div>
</template>

<script>
import G6 from '@antv/g6';
const COLLAPSE_ICON = function COLLAPSE_ICON(x, y, r) {
  return [
    ['M', x - r, y - r],
    ['a', r, r, 0, 1, 0, r * 2, 0],
    ['a', r, r, 0, 1, 0, -r * 2, 0],
    ['M', x + 2 - r, y - r],
    ['L', x + r - 2, y - r],
  ];
};
const EXPAND_ICON = function EXPAND_ICON(x, y, r) {
  return [
    ['M', x - r, y - r],
    ['a', r, r, 0, 1, 0, r * 2, 0],
    ['a', r, r, 0, 1, 0, -r * 2, 0],
    ['M', x + 2 - r, y - r],
    ['L', x + r - 2, y - r],
    ['M', x, y - 2 * r + 2],
    ['L', x, y - 2],
  ];
};
const traverseTree = (tree=[],title="root") => {
  return{
    id: title,
    label: title,
    children: tree,
    data:{
      type:"top"
    }
  }
}
const dataToTree=(from_list=[])=>{
  let to_list=[];
  from_list.map(ret=>{
    if(ret.type==='sub'){
      // let title=ret.value.filter(res=>res.type==='meter').map(res=>res.value).join('-')
      let title="仪表集-"+Math.random();
      to_list.push({
        id: title,
        label: title,
        data:ret,
        children:dataToTree(ret.value),
      });

    }else {
      to_list.push({
        id: ret.value,
        label: ret.value,
        data:ret,
      });
    }
  })
  return to_list;
}
export default {
  name: "VirtuallyMeterMap",
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      graph:null,
      expressions:[],
      sum_expressions:[],
      all_expressions:[],
      all_sum_expressions:[],
      all_expressions_tree:[],
      all_sum_expressions_tree:[],
    }
  },
  mounted() {
    const that=this;
    that.init();
    that.getData(()=>{
      let data=ERP.reJson(that.all_sum_expressions_tree);
      let data_tree=traverseTree(dataToTree(data));
      console.log(data_tree)
      that.setData(data_tree)
    })
  },
  methods:{
    getData(callback){
      const that=this;
      ERP.getRequest({
        url:"admin/MeterVirtually/getMeter",
        data:{
          dummy_id:that.mainObj.id,
        }
      },ret=>{
        if(ret.code){
          that.expressions=ret.data.expressions;
          that.sum_expressions=ret.data.sum_expressions;
          that.all_expressions=ret.data.all_expressions;
          that.all_sum_expressions=ret.data.all_sum_expressions;
          that.all_expressions_tree=ret.data.all_expressions_tree;
          that.all_sum_expressions_tree=ret.data.all_sum_expressions_tree;
          typeof callback==="function"&&callback()
        }
      })
    },
    init(){
      const that=this;
      G6.registerNode(
        'icon-node',
        {
          options: {
            size: [60, 20],
            stroke: '#91d5ff',
            fill: '#91d5ff',
          },
          draw(cfg, group) {
            const styles = this.getShapeStyle(cfg);
            const { labelCfg = {} } = cfg;

            const w = styles.width;
            const h = styles.height;

            if(cfg.data.type){

            }
            console.log(cfg)

            switch (cfg.data.operation) {
              case "+":
                styles.stroke="#91d5ff";
                styles.fill="#91d5ff";
                break;
              case "-":
                styles.stroke="#bec7cb";
                styles.fill="#bec7cb";
                break;
              case "*":
                styles.stroke="#a964b4";
                styles.fill="#a964b4";
                break;
              case "/":
                styles.stroke="#3b6ed9";
                styles.fill="#3b6ed9";
                break;
              default:break;
            }

            const keyShape = group.addShape('rect', {
              attrs: {
                ...styles,
                x: -w / 2,
                y: -h / 2,
              },
            });

            /**
             * leftIcon 格式如下：
             *  {
             *    style: ShapeStyle;
             *    img: ''
             *  }
             */
            console.log('cfg.leftIcon', cfg.leftIcon);
            if (cfg.leftIcon&&["sub"].includes(cfg.data.type)) {
              const { style, img } = cfg.leftIcon;
              group.addShape('rect', {
                attrs: {
                  x: 1 - w / 2,
                  y: 1 - h / 2,
                  width: 38,
                  height: styles.height - 2,
                  fill: '#8c8c8c',
                  ...style,
                },
              });

              group.addShape('image', {
                attrs: {
                  x: 8 - w / 2,
                  y: 8 - h / 2,
                  width: 24,
                  height: 24,
                  img:
                    img ||
                    'https://g.alicdn.com/cm-design/arms-trace/1.0.155/styles/armsTrace/images/TAIR.png',
                },
                // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
                name: 'image-shape',
              });
            }

            if(cfg.data.type==='sub'){
              // 如果不需要动态增加或删除元素，则不需要 add 这两个 marker
              group.addShape('marker', {
                attrs: {
                  x: 40 - w / 2,
                  y: 52 - h / 2,
                  r: 6,
                  stroke: '#73d13d',
                  cursor: 'pointer',
                  symbol: EXPAND_ICON,
                },
                // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
                name: 'add-item',
              });
            }
            group.addShape('marker', {
              attrs: {
                x: 80 - w / 2,
                y: 52 - h / 2,
                r: 6,
                stroke: '#ff4d4f',
                cursor: 'pointer',
                symbol: COLLAPSE_ICON,
              },
              // must be assigned in G6 3.3 and later versions. it can be any string you want, but should be unique in a custom item type
              name: 'remove-item',
            });

            if (cfg.label) {
              group.addShape('text', {
                attrs: {
                  ...labelCfg.style,
                  text: cfg.label,
                  x: 50 - w / 2,
                  y: 25 - h / 2,
                },
              });
            }

            return keyShape;
          },
          update: undefined,
        },
        'rect',
      );
      G6.registerEdge('flow-line', {
        draw(cfg, group) {
          const startPoint = cfg.startPoint;
          const endPoint = cfg.endPoint;

          const { style } = cfg;
          const shape = group.addShape('path', {
            attrs: {
              stroke: style.stroke,
              endArrow: style.endArrow,
              path: [
                ['M', startPoint.x, startPoint.y],
                ['L', startPoint.x, (startPoint.y + endPoint.y) / 2],
                ['L', endPoint.x, (startPoint.y + endPoint.y) / 2],
                ['L', endPoint.x, endPoint.y],
              ],
            },
          });

          return shape;
        },
      });

      const defaultStateStyles = {
        hover: {
          stroke: '#1890ff',
          lineWidth: 2,
        },
      };

      const defaultNodeStyle = {
        fill: '#91d5ff',
        stroke: '#40a9ff',
        radius: 5,
      };

      const defaultEdgeStyle = {
        stroke: '#91d5ff',
        endArrow: {
          path: 'M 0,0 L 12, 6 L 9,0 L 12, -6 Z',
          fill: '#91d5ff',
          d: -20,
        },
      };

      const defaultLayout = {
        type: 'compactBox',
        direction: 'TB',
        getId: function getId(d) {
          return d.id;
        },
        getHeight: function getHeight() {
          return 16;
        },
        getWidth: function getWidth() {
          return 16;
        },
        getVGap: function getVGap() {
          return 40;
        },
        getHGap: function getHGap() {
          return 70;
        },
      };

      const defaultLabelCfg = {
        style: {
          fill: '#000',
          fontSize: 12,
        },
      };

      const container = that.$refs.meterMap;
      const width = container.scrollWidth;
      const height = container.scrollHeight || 500;

      const minimap = new G6.Minimap({
        size: [150, 100],
      });
      const graph = new G6.TreeGraph({
        container: that.$refs.meterMap,
        width,
        height,
        linkCenter: true,
        plugins: [minimap],
        modes: {
          default: ['drag-canvas', 'zoom-canvas'],
        },
        defaultNode: {
          type: 'icon-node',
          size: [120, 40],
          style: defaultNodeStyle,
          labelCfg: defaultLabelCfg,
        },
        defaultEdge: {
          type: 'flow-line',
          style: defaultEdgeStyle,
        },
        nodeStateStyles: defaultStateStyles,
        edgeStateStyles: defaultStateStyles,
        layout: defaultLayout,
      });

      graph.on('node:mouseenter', (evt) => {
        const { item } = evt;
        graph.setItemState(item, 'hover', true);
      });

      graph.on('node:mouseleave', (evt) => {
        const { item } = evt;
        graph.setItemState(item, 'hover', false);
      });

      graph.on('node:click', (evt) => {
        const { item, target } = evt;
        const targetType = target.get('type');
        const name = target.get('name');

        // 增加元素
        if (targetType === 'marker') {
          const model = item.getModel();
          if (name === 'add-item') {
            if (!model.children) {
              model.children = [];
            }
            const id = `n-${Math.random()}`;
            model.children.push({
              id,
              label: id.substr(0, 8),
              leftIcon: {
                style: {
                  fill: '#e6fffb',
                  stroke: '#e6fffb',
                },
                img:
                  'https://gw.alipayobjects.com/mdn/rms_f8c6a0/afts/img/A*Q_FQT6nwEC8AAAAAAAAAAABkARQnAQ',
              },
              data:{}
            });
            graph.updateChild(model, model.id);
          } else if (name === 'remove-item') {
            graph.removeChild(model.id);
          }
        }
      });

      if (typeof window !== 'undefined'){
        window.onresize = () => {
          if (!graph || graph.get('destroyed')) return;
          if (!container || !container.scrollWidth || !container.scrollHeight) return;
          graph.changeSize(container.scrollWidth, container.scrollHeight);
        };
      }
      that.graph=graph;
    },
    setData(data){
      G6.Util.traverseTree(data, (d) => {
        d.leftIcon = {
          style: {
            fill: '#e6fffb',
            stroke: '#e6fffb',
          },
          img: 'https://gw.alipayobjects.com/mdn/rms_f8c6a0/afts/img/A*Q_FQT6nwEC8AAAAAAAAAAABkARQnAQ',
        };
        return true;
      });
      this.graph.data(data);
      this.graph.render();
      this.graph.fitView();
    }
  }
}

// const getTypeIcon()=
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/MeterVirtually/components/virtually/components/VirtuallyMeterMap.vue